import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { APP_VERSION, CHANGELOG } from '../../changelog';

export function ChangelogDialog({ onClose }: { onClose(): void }) {
  useEffect(() => {
    const closeOnEscape = (event: KeyboardEvent) => { if (event.key === 'Escape') onClose(); };
    window.addEventListener('keydown', closeOnEscape);
    return () => window.removeEventListener('keydown', closeOnEscape);
  }, [onClose]);

  return createPortal(
    <div className="changelog-backdrop" onMouseDown={(event) => event.target === event.currentTarget && onClose()}>
      <section className="changelog-dialog" role="dialog" aria-modal="true" aria-labelledby="changelog-title">
        <header>
          <div><span>Graphite · {APP_VERSION}</span><h2 id="changelog-title">История изменений</h2></div>
          <button autoFocus onClick={onClose} aria-label="Закрыть историю изменений">×</button>
        </header>
        <div className="changelog-releases">
          {CHANGELOG.map((release) => <article key={release.title}>
            <h3>{release.title}</h3>
            <ul>{release.changes.map((change) => <li key={change}>{change}</li>)}</ul>
          </article>)}
        </div>
      </section>
    </div>,
    document.body,
  );
}
